import React from 'react'
import './coretitle.scss'

function coreTitle({ imglabel, children }) {
  return <div className="coretitle_container">
    <img src={imglabel}></img>
    <p className="coretite">{children}</p>
  </div>
}

export default coreTitle